import type { FaireProductEntity } from "../../entity_types/product";

export const p_dvyjkw9jhv: FaireProductEntity = {
  token: "p_dvyjkw9jhv",
  type: "product",
  name: "Happy Plaid Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/35e6017bf9d1112938d6a4f7544ef3f0501836910f19e19d53bdc1bd4e675061.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b46eb4eb1a68f38f06e5b42792b2c31ec81a6ae4fa1152601f5722350ce3749f.jpeg",
    "https://cdn.faire.com/fastly/eaada9a07ca839b2c45c0e6085d5c14391e9bdb2db1d22b2a6793edbe043a559.jpeg",
  ],
  priceDollars: 5,
  description:
    "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:04.487Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
